/* eslint-disable security/detect-object-injection */
import { all, call, delay, put, select } from 'redux-saga/effects'
import i18next from 'i18next'
import { generatePath } from 'react-router'
import { recordCollectionAction } from 'utils/collectionActions'
import {
  fetchLatestTransactions,
  resetSelectedEntity,
  selectEntity
} from 'state/transaction/transaction.actions'
import { Action } from 'infra/types'
import { isWhatsappAlertBenefit, sendsOkcAlerts } from 'utils/alertBenefits'
import { MerchantApi } from 'services/Api/MerchantApi'
import { MerchantApiV2 } from 'services/Api/MerchantApiV2'
import { AuthStorageInstance } from 'services/Storage/AuthStorage'
import { forwardTo } from 'shared/state/common'
import { NotificationType } from 'pages/Notification/Notification.types'
import { addAutoFadeNotification } from 'pages/Notification/Notification.actions'
import { getErrorMessage } from 'services/Api/Errors'
import { getCurrentAddress } from 'services/Api/GeoLocator'
import { Navigation } from 'services/navigation'
import { IAppState } from 'infra/AppState'
import getWhatsappLink from 'utils/getWhatsappLink'
import { IApiResponse, API_RESPONSE_TYPE, ENTITY_TYPE } from 'shared/constants'
import { IDispatchCallback, IFilteredCustomersPayload } from 'services/Api/types'
import { newPaths } from 'shared/routes'
import {
  getFilteredCustomerList,
  linkDelinkAccountTags,
  updateRoutesAndBeats
} from 'services/Api/StafflinkApi'
import { getFilteredAccountsByBills } from 'services/Api/BillingApi'
import { IdentityApi, updateBusinessUser } from 'services/Api/IdentityApi'
import {
  getImageBackupDestination,
  setImageBackupDestination
} from 'services/ImageBackup/ImageBackupPreference'
import { setPaymentPinEnabled } from 'services/SecurityPin/securityPin'
import { setRecoveryMobile } from 'services/DataSecurity/recoveryMobile'
import { setGoogleDriveStatusAction } from 'state/settings/settings.action'
import { AuthApi } from 'services/Api/AuthApi'
import { setNewTokensToLocalStorage } from 'services/Api/apiInterceptor'
import {
  bulkUploadCustomersApi,
  getBulkUploadCustomersStatusApi
} from 'services/Api/growthExperimentApi'
import { DOCUMENT_TYPE } from 'state/new-summary/uploadSheet/uploadSheet.types'
import { getIsFeedbackDone, postFeedBack } from 'services/Api/PaidSoonBannerApi'
import { validateGST } from 'pages/NewDashboard/components/Billing/Helper'
import { validatePhoneNumber } from 'utils/validators/phoneNumberValidator'
import {
  fetchUserPermission,
  getAllCustomerProfilesApi,
  getBrandProfile,
  getBusinessConfig
} from 'services/Api/StaffLinkApiFolder/api'
import { DOCUMENT_STATUS } from 'pages/NewDashboard/components/CommonDrawers/UploadSheetDrawers/UploadSupplySheet/components/DocumentCard/DocumentCard.types'
import {
  BUSINESS_CONFIG_RESPONSE,
  FETCH_PERMISSION_RESPONSE
} from 'services/Api/StaffLinkApiFolder/type'
import { linkDelinkAccountTagsPayload } from 'state/tags/tags.types'
import { getAccountTagsSuccess, getBusinessLabelsKeyVals } from 'state/tags/tags.actions'
import { fetchBusinessSettingsApi } from 'services/Api/BillingApiFolder.ts/api'
import { CustomerListAndMerchantListApi } from 'services/Api/CustomerListAndMerchantList'
import { CustomerAndSupplierApi } from 'services/Api/CustomerAndSupplierApi'
import { getTransactionDatabaseManager } from 'services/IndexDB/TransactionDatabaseManager'
import { deriveLastActivity, ILastActivity } from 'utils/lastActivity'
import { MerchantHelpApi } from 'services/Api/MerchantHelpApi'
import { seedTransactions } from 'state/seed/seed.action'
import { initRealtimeSync } from 'state/realtime/realtime.actions'
import {
  closeSelectAccountModal,
  showSelectAccountModal,
  showSuccessModal,
  signout
} from '../auth/auth.actions'
import { MerchantProfileHelpers } from './helpers/MerchantProfile'
import {
  CustomerSupplierProfileHelpers,
  getFormattedCustomerProfile,
  getFormattedSupplierProfile,
  getResetCustomerProfile,
  getResetSupplierProfile,
  IEntityUpdateObject
} from './helpers/CustomerSupplierProfile'
import {
  registerMerchantNameSuccesss,
  fetchLocalDataSuccess,
  fetchMerchantProfileSuccess,
  updateMerchantProfile,
  showBusinessNameModal,
  fetchBusinessCategoriesSuccess,
  fetchBusinessTypesSuccess,
  fetchPhonebookContactsSuccess,
  editMerchantProfile,
  fetchHelpSectionsSuccess,
  businessNameOptOut as businessNameOptOutAction,
  fetchEntityListSuccess,
  updateEntity,
  deleteEntitySuccess,
  addEntitySuccess,
  fetchEntityList,
  fetchMerchantProfileFailure,
  fetchEntityListFailure,
  fetchPhonebookContactsFailure,
  fetchHelpSectionsFailure,
  getCustomerDataSuccess,
  fetchCustomerDuesInfo,
  setCustomerDuesInfo,
  fetchLastActivity,
  setLastActivity,
  setShowLeadgenBanner,
  fetchFilteredCustomerListSuccess,
  fetchFilteredCustomerListFailure,
  handleSearchByValueSuccess,
  handleSearchByValueFailure,
  setBusinessAccountsLoaderAction,
  setBusinessDetailsAction,
  fetchBusinessIdsSuccessAction,
  createBusinessSuccessAction,
  handleBusinessAccountsDrawerToggle,
  switchBusinessAccountAction,
  setAsStaffBusinessDetailsAction,
  selectBusinessAccountAction,
  bulkUploadCustomersSuccessAction,
  stopPollBulkUploadAccountsStatus,
  bulkUploadCustomersStatusSuccessAction,
  setLoaderAction,
  closePaidSoonBannerAction,
  openPaidSoonBannerAction,
  setBusinessManagersAction,
  fetchBusinessManagersAction,
  setBusinessManagerActionInProgressAction,
  setCustomerProfilesData,
  fetchCustomerProfiles,
  setDrawerAction,
  setBusinessSettingsAction,
  setBrandData,
  setBusinessConfig,
  fetchMerchantBusinessConfigSuccess,
  fetchMerchantProfile as fetchMerchantProfileAction,
  editEntity,
  markTxnAlertSettingSeen as markTxnAlertSettingSeenAction,
  clearPendingTxnAlertUpgrade,
  IAccountProfileImagePayload
} from './dashboard.actions'
import {
  ITxnAlertNudge,
  IPendingTxnAlertUpgrade,
  ICustomer,
  IDashboardState,
  IEntityEdit,
  IMerchantProfile,
  IMerchantProfileEdited,
  IPhonebookContact,
  ISupplier,
  IInitialLeadgenAction,
  addAccountBeatRoutePayload,
  CustomerProfileBulkUpdateEntity
} from './dashboard.types'
import { getFormattedHelpSection } from './helpers/helpSection'
import { formatCustomerProfiles, getFormattedAccountIds } from './helpers/formatter'
import { formatBusinessDetail, formatBusinessDetailsResponse } from './helpers/businessAccounts'
import {
  BULK_UPLOAD_ACCOUNTS_STATUS_POLL_COUNT,
  BULK_UPLOAD_ACCOUNTS_STATUS_POLL_INTERVAL
} from './helpers/account'
import { isBetween2pmAnd4pm, saveLocalStorageData } from './helpers/paidSoonBanner'

export function* setMerchantName(action: Action<string>) {
  try {
    const response: IApiResponse = yield call(MerchantApi.registerMerchantName, action.payload)
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      yield put(registerMerchantNameSuccesss())
      yield put(businessNameOptOutAction())
    } else {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: response.data.message
        })
      )
    }
  } catch (e: any) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message
      })
    )
  }
}

export function* businessNameOptOut() {
  yield AuthStorageInstance.setOptoutBusinessName(true)
}

export function* fetchAndSetLocalData() {
  const businessNameOptOut: boolean = yield AuthStorageInstance.getOptoutBusinessName()
  const isNewUser: boolean = yield AuthStorageInstance.getFirstTimeUser()
  if (isNewUser) {
    yield put(showBusinessNameModal())
  }
  yield put(fetchLocalDataSuccess(businessNameOptOut))
}

export function* fetchEntities(action: Action<ENTITY_TYPE>) {
  const entityType = action.payload
  const isCustomer = entityType === ENTITY_TYPE.CUSTOMER

  try {
    const response: IApiResponse = yield call(
      isCustomer
        ? CustomerListAndMerchantListApi.getCustomersList
        : CustomerListAndMerchantListApi.getSuppliersList
    )
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      const entities = isCustomer ? response.data : response.data?.suppliers
      if (entities && entities.length) {
        const list = entities
          .filter((_: any) => !_.deleted)
          .map(
            isCustomer
              ? CustomerSupplierProfileHelpers.getFormattedCustomerProfile
              : CustomerSupplierProfileHelpers.getFormattedSupplierProfile
          )
        yield put(fetchEntityListSuccess(entityType, list))

        if (isCustomer) {
          yield put(fetchCustomerDuesInfo())
        }
        // Rich last-activity subtitle applies to both customers and suppliers.
        yield put(fetchLastActivity(entityType))

        // NOTE: we intentionally do NOT purge cached transactions for entities
        // missing from the active list. The proto seed stores all customers'
        // (incl. deleted) transactions and we keep them offline-first; a re-added
        // same-id customer will show old cached txns by design. See plan §9.
      }
    } else if (response?.data?.response && response?.data?.response?.status === 401) {
      yield put(signout())
    } else {
      const currentPath: string = yield select((state: IAppState) => {
        return state.Navigation.currentRoute.pathName
      })
      if (currentPath !== '') {
        yield put(fetchEntityListFailure(entityType))
        yield put(
          addAutoFadeNotification({
            type: NotificationType.ERROR,
            bodyText: response.data.message
          })
        )
      }
    }
  } catch (e: any) {
    const currentPath: string = yield select((state: IAppState) => {
      return state.Navigation.currentRoute.pathName
    })
    if (currentPath !== '') {
      yield put(fetchEntityListFailure(entityType))
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: getErrorMessage(e).message
        })
      )
    }
  }
}

export function* patchEntity(action: Action<IEntityUpdateObject>) {
  const { entityId, entityType } = action.payload
  const isCustomer = entityType === ENTITY_TYPE.CUSTOMER
  const entity: ICustomer & ISupplier = yield select(
    (state) => state.Dashboard[isCustomer ? 'customers' : 'suppliers'].byIds[entityId]
  )

  let apiService
  let payloadGenerator
  let formatter
  let resetter

  if (isCustomer) {
    apiService = CustomerAndSupplierApi.patchCustomer
    payloadGenerator = CustomerSupplierProfileHelpers.getPatchCustomerPayload
    formatter = getFormattedCustomerProfile
    resetter = getResetCustomerProfile
  } else {
    apiService = CustomerAndSupplierApi.patchSupplier
    payloadGenerator = CustomerSupplierProfileHelpers.getPatchSupplierPayload
    formatter = getFormattedSupplierProfile
    resetter = getResetSupplierProfile
  }
  //If there is some sort of a race condtion & the entity has been deleted
  if (
    !entity ||
    (entity.edited.values.customer_gst && !validateGST(entity.edited.values.customer_gst))
  ) {
    return
  }
  const editedMobile = entity.edited.values.mobile
  const originalMobile = entity.mobile
  if (editedMobile !== originalMobile && !validatePhoneNumber(editedMobile)) {
    return
  }

  try {
    const response: IApiResponse = yield call(apiService, entityId, payloadGenerator(entity as any))
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      yield put(updateEntity(formatter(isCustomer ? response.data : response.data.supplier)))
    } else {
      const err = response.data as any
      const status = err?.response?.status
      const errorCode = err?.response?.data?.error
      const isConflict =
        status === 409 && (errorCode === 'customer_exists' || errorCode === 'supplier_exists')

      if (isConflict) {
        const conflictMobile = entity.edited.values.mobile
        let conflictMessage = ''
        const dashboard: IDashboardState = yield select((state: IAppState) => state.Dashboard)
        const activeMap = isCustomer
          ? dashboard.customers?.byIds || {}
          : dashboard.suppliers?.byIds || {}
        const activeMatch = Object.values(activeMap).find(
          (e: any) => e && e.id !== entityId && e.mobile === conflictMobile
        ) as ICustomer | ISupplier | undefined

        if (activeMatch) {
          const matchName = isCustomer
            ? (activeMatch as ICustomer).description || (activeMatch as any).name
            : (activeMatch as ISupplier).name
          conflictMessage = `"${conflictMobile}" is already in your ${
            isCustomer ? 'Customers' : 'Suppliers'
          } list with name "${matchName}"`
        } else {
          const deletedListResp: IApiResponse = yield call(
            isCustomer
              ? CustomerListAndMerchantListApi.getDeletedCustomersList
              : CustomerListAndMerchantListApi.getDeletedSuppliersList
          )
          if (deletedListResp.type === API_RESPONSE_TYPE.SUCCESS) {
            const list = isCustomer ? deletedListResp.data : deletedListResp.data?.suppliers
            const deletedMatch = (list || []).find((e: any) => e?.mobile === conflictMobile)
            if (deletedMatch) {
              const deletedName = isCustomer
                ? deletedMatch.description || deletedMatch.name || ''
                : deletedMatch.name || ''
              const entityWord = isCustomer ? 'Customer' : 'Supplier'
              const nameSuffix = deletedName ? ` (${deletedName})` : ''
              conflictMessage = `${entityWord} mobile number "${conflictMobile}"${nameSuffix} existed and account deleted. Please add as new ${entityWord.toLowerCase()} again`
            }
          }
        }
        yield put(
          addAutoFadeNotification({
            type: NotificationType.ERROR,
            bodyText: conflictMessage || getErrorMessage(err).message
          })
        )
        // Flag the mobile field with errors.mobile = true so the TextInput renders
        // its inline red error state. Pull the latest entity from Redux first so
        // we don't clobber any keystrokes that happened during the API round-trip.
        const latestEntity: ICustomer & ISupplier = yield select(
          (s: IAppState) => s.Dashboard[isCustomer ? 'customers' : 'suppliers'].byIds[entityId]
        )
        if (latestEntity) {
          yield put(
            updateEntity({
              ...latestEntity,
              edited: {
                values: { ...latestEntity.edited.values },
                errors: { ...latestEntity.edited.errors, mobile: true }
              }
            })
          )
        }
        // Intentionally do NOT call updateEntity(resetter(entity)) — keep the
        // user's typed value in Redux so they can see what they entered and
        // correct it. (Server already rejected the update so nothing is saved.)
      } else {
        yield put(
          addAutoFadeNotification({
            type: NotificationType.ERROR,
            bodyText: getErrorMessage(err).message
          })
        )
        yield put(updateEntity(resetter(entity)))
      }
    }
  } catch (e: any) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message
      })
    )
  }
}

export function* deleteEntity(action: Action<IEntityEdit & IDispatchCallback>) {
  const { id, entityType, redirectTo } = action.payload
  const isCustomer = entityType === ENTITY_TYPE.CUSTOMER
  try {
    const response: IApiResponse = yield call(
      CustomerAndSupplierApi[isCustomer ? 'deleteCustomer' : 'deleteSupplier'],
      id
    )
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      // NOTE: we intentionally KEEP a deleted customer's cached transactions
      // (offline-first). A re-added same-id customer will show the old cached
      // txns by design. See plan §9.
      const currentPath: string = yield select((state: IAppState) => {
        return state.Navigation.currentRoute.pathName
      })
      if (redirectTo) {
        yield call(forwardTo, redirectTo)
      } else if (currentPath === 'editEntity') {
        Navigation().back()
      }
      yield put(deleteEntitySuccess(entityType, id))
      yield put(resetSelectedEntity())
    } else {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: response.data.message
        })
      )
    }
  } catch (e: any) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message
      })
    )
  }
}

export function* fetchMerchantProfile() {
  try {
    const currentBusinessId: string = yield AuthStorageInstance.getCurrentBusinessId()
    if (!currentBusinessId) {
      return
    }
    const response: IApiResponse = yield call(IdentityApi.getBusinessUser, currentBusinessId)

    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      yield put(fetchMerchantProfileSuccess(formatBusinessDetail(response)))
      yield call(fetchBusinessCategories)
      yield call(fetchBusinessTypes)
    } else {
      const currentPath: string = yield select((state: IAppState) => {
        return state.Navigation.currentRoute.pathName
      })
      if (currentPath !== '') {
        yield put(fetchMerchantProfileFailure())
        yield put(
          addAutoFadeNotification({
            type: NotificationType.ERROR,
            bodyText: response.data.message
          })
        )
      }
    }
  } catch (e: any) {
    const currentPath: string = yield select((state: IAppState) => {
      return state.Navigation.currentRoute.pathName
    })
    if (currentPath !== '') {
      yield put(fetchMerchantProfileFailure())
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: getErrorMessage(e).message
        })
      )
    }
  }
}

export function* checkForPaidBannerSoon() {
  try {
    const checkIsBetween2pmAnd4pm: Boolean = yield call(isBetween2pmAnd4pm)
    const isExperimentEnable: boolean = yield call(checkForExperimentEnable)
    if (checkIsBetween2pmAnd4pm) {
      if (isExperimentEnable) {
        const checkForLocalStorage: Boolean = yield call(saveLocalStorageData)
        if (checkForLocalStorage) {
          const response: IApiResponse = yield call(getIsFeedbackDone)
          if (response.type === API_RESPONSE_TYPE.SUCCESS) {
            if (!response.data?.message) {
              yield put(openPaidSoonBannerAction())
            } else {
              window.localStorage.setItem('isBannerSeen', 'true')
            }
          }
          if (response.type === API_RESPONSE_TYPE.FAILURE) {
            window.localStorage.removeItem('isBannerSeen')
            window.localStorage.removeItem('lastBannerShownDate')
          }
        }
      }
    }
  } catch (e: any) {
    yield put(closePaidSoonBannerAction())
  }
}

function* checkForExperimentEnable() {
  try {
    const { Experiment } = yield select((app: IAppState) => app)
    return (
      Experiment?.experiment['activation_web-all-paid_soon_banner'].status === 1 &&
      Experiment?.experiment['activation_web-all-paid_soon_banner'].variant === 'test'
    )
  } catch (error) {
    return false
  }
}

export function* closePaidBannerSoonBanner() {
  try {
    window.localStorage.setItem('isBannerSeen', 'false')
    const currentDate = new Date().toISOString().slice(0, 10)
    window.localStorage.setItem('lastBannerShownDate', currentDate)
  } catch (e: any) {
    yield put(closePaidSoonBannerAction())
  }
}

export function* postPaidBannerSoonFeedback(action: Action<string>) {
  try {
    const payload = {
      feature: 'subscription_notification',
      message: action?.payload || ''
    }
    const response: IApiResponse = yield call(postFeedBack, payload)
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      window.localStorage.setItem('isBannerSeen', 'true')
      yield put(closePaidSoonBannerAction())
    }
  } catch (e: any) {
    yield put(closePaidSoonBannerAction())
  }
}

export function* patchMerchantProfile() {
  const merchantProfile: { edited: IMerchantProfileEdited; data: IMerchantProfile } = yield select(
    (state) => state.Dashboard.merchantProfile
  )
  const currentBusinessId: string = yield AuthStorageInstance.getCurrentBusinessId()
  const { edited: merchantProfileEdited, data: merchantProfileOriginal } = merchantProfile
  const payload = MerchantProfileHelpers.getMerchantProfilePatchPayloadV2(
    merchantProfileEdited,
    merchantProfileOriginal
  )

  try {
    const response: IApiResponse = yield call(updateBusinessUser, payload)
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      if (response.data.is_updated) {
        if (payload.update_udyam_number) {
          yield delay(3000)
          const response: IApiResponse = yield call(IdentityApi.getBusinessUser, currentBusinessId)
          if (response.type === API_RESPONSE_TYPE.SUCCESS) {
            yield put(updateMerchantProfile(formatBusinessDetail(response.data)))
          }
        } else {
          yield put(updateMerchantProfile(formatBusinessDetail(response.data)))
        }
      }
    } else {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: getErrorMessage(response.data).message
        })
      )
      yield put(updateMerchantProfile(merchantProfileOriginal))
    }
  } catch (e: any) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message
      })
    )
  }
}

export function* getCustomerDataEffect(action: Action<string>) {
  try {
    const customerId = action.payload
    const response: IApiResponse = yield call(CustomerAndSupplierApi.getCustomerData, customerId)
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      yield put(getCustomerDataSuccess(getFormattedCustomerProfile(response.data)))
    } else {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: response.data.message
        })
      )
    }
  } catch (e: any) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message
      })
    )
  }
}

export function* fetchCustomerDuesInfoEffect() {
  try {
    const businessId: string = yield AuthStorageInstance.getCurrentBusinessId()
    if (!businessId) {
      return
    }
    const response: IApiResponse = yield call(
      CustomerAndSupplierApi.listCustomerDuesInfo,
      businessId
    )
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      const dues = (response.data?.dues_info || [])
        .filter((d: any) => d?.account_id && d?.is_due_active && Number(d?.active_date) > 0)
        .map((d: any) => ({
          customerId: d.account_id,
          dueDate: Number(d.active_date) * 1000
        }))
      yield put(setCustomerDuesInfo(dues))
    }
  } catch (e: any) {
    console.warn('[fetchCustomerDuesInfo] failed:', getErrorMessage(e).message)
  }
}

export function* updateCustomerDueDateEffect(
  action: Action<{ customerId: string; dueDate: number | null }>
) {
  const { customerId, dueDate } = action.payload
  try {
    const dueDateInSeconds = dueDate === null ? null : Math.floor(dueDate / 1000)
    const response: IApiResponse = yield call(
      CustomerAndSupplierApi.updateCustomerDueDate,
      customerId,
      dueDateInSeconds
    )
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      if (dueDate) {
        // Android CollectionScreenModel: setting (not clearing) a due date is a
        // collection action for the Recommended sort's cooldown
        const businessId: string = yield select(
          (app: IAppState) => app.Dashboard.merchantProfile?.data?.id || ''
        )
        recordCollectionAction(businessId, customerId, 'DUE_DATE')
      }
      yield put(fetchCustomerDuesInfo())
    } else {
      yield put(fetchCustomerDuesInfo())
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: response.data?.message || 'Could not update due date'
        })
      )
    }
  } catch (e: any) {
    yield put(fetchCustomerDuesInfo())
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message
      })
    )
  }
}

// Builds the rich last-activity subtitle for every account of a type from the IndexedDB
// transaction cache (Android computes this locally too — the list API doesn't return
// it). One cache scan derives each account's latest transaction. Silent on failure;
// the subtitle just falls back to "Last activity on {date}".
export function* fetchLastActivityEffect(action: Action<ENTITY_TYPE>) {
  const entityType = action.payload
  try {
    const dbManager = getTransactionDatabaseManager()
    yield call([dbManager, 'init'])
    const byAccount: Record<string, any[]> = yield call(
      [dbManager, 'getTransactionsByType'],
      entityType
    )
    const map: Record<string, ILastActivity> = {}
    Object.keys(byAccount || {}).forEach((accountId) => {
      const activity = deriveLastActivity(byAccount[accountId])
      if (activity) {
        map[accountId] = activity
      }
    })
    yield put(setLastActivity({ entityType, map }))
  } catch (e: any) {
    console.warn('[fetchLastActivity] failed:', getErrorMessage(e).message)
  }
}

export function* patchMerchantAddressWithCurrentLocation() {
  //@ts-ignore
  const address = yield call(getCurrentAddress)
  if (!address) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: "Oops! We couldn't auto-detect your address."
      })
    )
  } else {
    yield put(editMerchantProfile('address', address))
  }
}

export function* fetchBusinessCategories() {
  try {
    const response: IApiResponse = yield call(MerchantApi.getBusinessCategories)

    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      if (response.data && response.data.categories) {
        const { categories } = response.data
        yield put(
          fetchBusinessCategoriesSuccess(
            categories.map((category: any) => ({
              type: category.type,
              id: category.id,
              name: category.name,
              imageUrl: category.image_url,
              isPopular: category.is_popular,
              weight: category.weight
            }))
          )
        )
      }
    } else {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: response.data.message
        })
      )
    }
  } catch (e: any) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message
      })
    )
  }
}

export function* fetchBusinessTypes() {
  try {
    const response: IApiResponse = yield call(MerchantApiV2.getBusinessTypes)

    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      if (response.data && response.data.business_type) {
        const business_types = response.data.business_type
        yield put(
          fetchBusinessTypesSuccess(
            business_types.map((business_type: any) => ({
              id: business_type.id,
              name: business_type.name,
              imageUrl: business_type.image_url,
              title: business_type.title,
              subTitle: business_type.sub_title
            }))
          )
        )
      }
    } else {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: response.data.message
        })
      )
    }
  } catch (e: any) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message
      })
    )
  }
}

const checkExists = (mobileNumber: string, state: IDashboardState) => {
  const customers = Object.values(state.customers.byIds)
  const suppliers = Object.values(state.suppliers.byIds)
  let exists = false
  if (customers.length) {
    exists = customers.some((customer: ICustomer) => customer.mobile === mobileNumber)
  }
  if (!exists && suppliers.length) {
    exists = suppliers.some((supplier: ISupplier) => supplier.mobile === mobileNumber)
  }
  return exists
}

export function* addEntity(action: Action<any>) {
  try {
    const { mobile: mobileNumber, entityType, redirectTo } = action.payload
    const isCustomer = entityType === ENTITY_TYPE.CUSTOMER
    const dashboardState: IDashboardState = yield select((state) => state.Dashboard)
    if (checkExists(mobileNumber, dashboardState)) {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: 'User already exists as either Customer or Supplier. Cannot add'
        })
      )
      return
    }
    const response: IApiResponse = yield call(
      isCustomer ? CustomerAndSupplierApi.addCustomer : CustomerAndSupplierApi.addSupplier,
      action.payload.name,
      action.payload.mobile
    )
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      yield put(
        addEntitySuccess(
          entityType,
          response.data.mobile,
          action.payload.fromContactList,
          action.payload.isRegistered,
          response.data.id
        )
      )
      yield put(fetchEntityList(entityType))
      yield put(selectEntity(entityType, response.data.id))
      // Same as clicking the row: load this account's ledger so the pane shows ITS (empty)
      // state at once instead of the previously selected account's rows.
      yield put(fetchLatestTransactions({ entityType, entityId: response.data.id }))
      if (redirectTo) {
        yield call(forwardTo, redirectTo)
      } else {
        // Straight to the new account's ledger (already selected above) — no "Well Done"
        // popup in between, as on mobile
        Navigation().replace(newPaths.ledger)
      }
    } else {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: response.data.message
        })
      )
    }
  } catch (e: any) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message
      })
    )
  }
}

export function* fetchPhonebookContacts() {
  try {
    const response: IApiResponse = yield call(MerchantApi.getContactsFromMerchant)
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      if (response.data && response.data.contacts && response.data.contacts.length > 0) {
        const contacts: IPhonebookContact[] = response.data.contacts.map(
          (_: any): IPhonebookContact => ({ name: _.name, mobile: _.mobile })
        )
        yield put(fetchPhonebookContactsSuccess(contacts))
      }
    } else {
      const currentPath: string = yield select((state: IAppState) => {
        return state.Navigation.currentRoute.pathName
      })
      if (currentPath !== '') {
        yield put(fetchPhonebookContactsFailure())
        yield put(
          addAutoFadeNotification({
            type: NotificationType.ERROR,
            bodyText: response.data.message
          })
        )
      }
    }
  } catch (e: any) {
    const currentPath: string = yield select((state: IAppState) => {
      return state.Navigation.currentRoute.pathName
    })
    if (currentPath !== '') {
      yield put(fetchPhonebookContactsFailure())
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: getErrorMessage(e).message
        })
      )
    }
  }
}

export function* fetchHelpSections(action: Action<string>) {
  try {
    const response: IApiResponse = yield call(MerchantHelpApi.getHelpSection, action.payload)

    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      if (Array.isArray(response.data.sections)) {
        const helpSections = response.data.sections.map(getFormattedHelpSection)
        yield put(fetchHelpSectionsSuccess(helpSections))
      }
    } else {
      yield put(fetchHelpSectionsFailure())
      console.log('Error with /api/account/help api')
      // yield put(
      //   addAutoFadeNotification({
      //     type: NotificationType.ERROR,
      //     bodyText: response.data.message
      //   })
      // )
    }
  } catch (e: any) {
    yield put(fetchHelpSectionsFailure())
    console.log('Error with /api/account/help api')
    // yield put(
    //   addAutoFadeNotification({
    //     type: NotificationType.ERROR,
    //     bodyText: getErrorMessage(e).message
    //   })
    // )
  }
}

export function contactUsOnWhatsApp() {
  // eslint-disable-next-line security/detect-non-literal-fs-filename
  window.open(getWhatsappLink('+91 82965 08123', ''))
}

export function* handleInitialLeadgenEffect(action: Action<IInitialLeadgenAction>) {
  if (typeof window === 'undefined') {
    return null
  }
  let showBannerState: string | null = 'false'
  let showLeadgen: boolean = false

  if (action.payload.queryString) {
    const queryParams = new window.URLSearchParams(action.payload.queryString)
    showBannerState = queryParams.get('lgl')
    if (showBannerState && action?.payload?.history) {
      queryParams.delete('lgl')
      action?.payload?.history.push({
        search: queryParams.toString()
      })
    }
  } else {
    showBannerState = window.localStorage.getItem('showLeadgenBanner')
  }
  if (showBannerState && showBannerState === 'true') {
    showLeadgen = true
    window.localStorage.setItem('showLeadgenBanner', 'true')
  } else {
    showLeadgen = false
    window.localStorage.removeItem('showLeadgenBanner')
  }
  yield put(setShowLeadgenBanner(showLeadgen))
}

export function* fetchFilteredByTagsCustomers(action: Action<IFilteredCustomersPayload>) {
  try {
    const response: IApiResponse = yield call(getFilteredCustomerList, action.payload)

    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      const entities = response.data.customers
      if (entities && entities.length) {
        const list = entities
          .filter((_: any) => !_.deleted)
          .map(CustomerSupplierProfileHelpers.getFormattedCustomerProfile)
        yield put(fetchFilteredCustomerListSuccess(list))
      } else {
        yield put(fetchFilteredCustomerListSuccess(undefined))
      }
    } else {
      yield put(fetchFilteredCustomerListFailure(null))
      console.log('Error with /v1/FilterAccountsByTags')
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: 'Could not apply this filter. Please try again after some time.'
        })
      )
    }
  } catch (e: any) {
    yield put(fetchFilteredCustomerListFailure(null))
    console.log('Error with /v1/FilterAccountsByTags')
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: 'Could not apply this filter. Please try again after some time.'
      })
    )
  }
}

export function* fetchSearchByValueAccounts() {
  try {
    const dashboardState: IDashboardState = yield select((state: IAppState) => {
      return state.Dashboard
    })
    const response: IApiResponse = yield call(
      getFilteredAccountsByBills,
      dashboardState.searchString
    )
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      const formattedAccounts = getFormattedAccountIds(response.data.bills)
      yield put(handleSearchByValueSuccess(formattedAccounts))
    } else {
      yield put(handleSearchByValueFailure())
      console.log('Error with /v1/FilterAccountsByTags')
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: 'Bill Number does not exist. Please try with valid number'
        })
      )
    }
  } catch (error) {
    console.log('Error with /v1/fetchByHills')
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: 'Could not search by value'
      })
    )
  }
}

export function* getBusinessIdsEffect(action: Action<{ isSigningIn: boolean }>) {
  try {
    const { isSigningIn } = action.payload
    const currentBusinessId: string = yield AuthStorageInstance.getCurrentBusinessId()
    const isAdmin: boolean = yield AuthStorageInstance.getIsAdmin()

    yield put(setBusinessAccountsLoaderAction(true))
    const response: IApiResponse = yield call(IdentityApi.getBusinessIds)

    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      const businessIds: string[] = response?.data?.business_ids || []
      const businessesStaff: any[] = response?.data?.allowed_businesses || []
      const businessIdsAsStaff: string[] = businessesStaff.map((business) => business.id)
      const businessConfigWithBusinessId: Record<string, BUSINESS_CONFIG_RESPONSE> = {}
      if (businessIds.length) {
        const responses: IApiResponse[] = yield all(
          businessIds.map((businessId) => call(IdentityApi.getBusinessUser, businessId))
        )

        const businessConfigsResponse: IApiResponse[] = yield all(
          businessIds.map(() =>
            call(
              getBusinessConfig,
              response.data?.individual_user?.user?.id
                ? { logged_in_user_id: response.data?.individual_user?.user?.id }
                : {}
            )
          )
        )

        const brandWithBusinessId: any = {}
        businessConfigsResponse.forEach((response, index) => {
          brandWithBusinessId[businessIds[index]] = !!response?.data?.distributor_info?.is_brand
          businessConfigWithBusinessId[businessIds[index]] = response?.data
        })

        const allBrandBusinessesIds = Object.keys(brandWithBusinessId).filter(
          (key) => brandWithBusinessId[key] === true
        )

        const brandData: any = {}
        if (allBrandBusinessesIds?.length) {
          const brandDataResponse: IApiResponse[] = yield all(
            allBrandBusinessesIds.map(() => call(getBrandProfile))
          )
          brandDataResponse.forEach((response, index) => {
            if (response.type === API_RESPONSE_TYPE.SUCCESS) {
              const distributorNameToDistributorIdMap: Record<string, Array<string>> = {}
              const distributorRegionToDistributorIdMap: Record<string, Array<string>> = {}
              const distributorBranchToDistributorIdMap: Record<string, Array<string>> = {}

              response.data.distributors.forEach((distributorData: any) => {
                distributorNameToDistributorIdMap[distributorData.distributor_name] = [
                  ...(distributorNameToDistributorIdMap[distributorData.distributor_name]
                    ? distributorNameToDistributorIdMap[distributorData.distributor_name]
                    : []),
                  distributorData.distributor_id
                ]

                distributorRegionToDistributorIdMap[distributorData.region || 'No Region'] = [
                  ...(distributorRegionToDistributorIdMap[distributorData.region || 'No Region']
                    ? distributorRegionToDistributorIdMap[distributorData.region || 'No Region']
                    : []),
                  distributorData.distributor_id
                ]

                distributorBranchToDistributorIdMap[distributorData.branch || 'No Branch'] = [
                  ...(distributorBranchToDistributorIdMap[distributorData.branch || 'No Branch']
                    ? distributorBranchToDistributorIdMap[distributorData.branch || 'No Branch']
                    : []),
                  distributorData.distributor_id
                ]
              })

              brandData[allBrandBusinessesIds[index]] = {
                ...response.data,
                distributorDataByIds: response.data.distributors.reduce(
                  (acc: any, distributorData: any) => {
                    acc[distributorData.distributor_id] = distributorData
                    return acc
                  },
                  {}
                ),
                distributorNameToDistributorIdMap,
                distributorRegionToDistributorIdMap,
                distributorBranchToDistributorIdMap
              }
            }
          })
        }
        const formattedResponse = formatBusinessDetailsResponse(
          responses,
          brandWithBusinessId,
          businessIds
        )

        yield put(setBusinessDetailsAction(formattedResponse))
        yield put(setBrandData(brandData))
      }
      if (businessIdsAsStaff.length) {
        const responses: IApiResponse[] = yield all(
          businessIdsAsStaff.map((businessId) => call(IdentityApi.getBusinessUser, businessId))
        )

        const businessConfigsResponseData: IApiResponse[] = yield all(
          businessIdsAsStaff.map(() =>
            call(
              getBusinessConfig,
              response.data?.individual_user?.user?.id
                ? { logged_in_user_id: response.data?.individual_user?.user?.id }
                : {}
            )
          )
        )

        businessConfigsResponseData.forEach((response, index) => {
          businessConfigWithBusinessId[businessIdsAsStaff[index]] = response?.data
        })

        const formattedResponse = formatBusinessDetailsResponse(responses)
        yield put(setAsStaffBusinessDetailsAction(formattedResponse))
      }

      if (Object.keys(businessConfigWithBusinessId).length) {
        yield put(setBusinessConfig({ data: businessConfigWithBusinessId }))
      }

      let permittedWorkflows
      if (response?.data?.individual_user?.user?.id) {
        const payload = {
          user_id: response.data.individual_user.user.id
        }
        const permissionResponse: IApiResponse<FETCH_PERMISSION_RESPONSE> = yield call(
          fetchUserPermission,
          payload
        )
        permittedWorkflows = permissionResponse.data.permitted_workflows
      }

      setImageBackupDestination(response?.data?.individual_user?.image_backup_destination)
      setPaymentPinEnabled(response?.data?.individual_user?.payment_password_enabled)
      setRecoveryMobile(response?.data?.individual_user?.alternate_mobile)
      yield put(setGoogleDriveStatusAction({ imageBackupDestination: getImageBackupDestination() }))

      yield put(
        fetchBusinessIdsSuccessAction({
          businessIds: businessIds,
          individualUser: response?.data?.individual_user?.user,
          asStaffBusinessIds: businessIdsAsStaff,
          ...(permittedWorkflows && permittedWorkflows.length > 0 && { permittedWorkflows })
        })
      )
      if (isSigningIn || !currentBusinessId) {
        // Auto-select if only one business, otherwise show modal
        if (businessIdsAsStaff.length === 0 && businessIds.length === 1) {
          yield put(selectBusinessAccountAction({ businessId: businessIds[0], isAdmin: true }))
        } else if (businessIdsAsStaff.length + businessIds.length > 0) {
          yield put(showSelectAccountModal())
        }
      } else {
        yield put(selectBusinessAccountAction({ businessId: currentBusinessId, isAdmin }))
      }
    }
    yield put(setBusinessAccountsLoaderAction(false))
  } catch (e: any) {
    console.log(e)
    yield put(setBusinessAccountsLoaderAction(false))
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: e.message
      })
    )
  }
}

export function* fetchBusinessSettingsEffect() {
  const { Dashboard } = yield select((app: IAppState) => app)
  const merchantId: string = Dashboard?.merchantProfile?.data?.id

  const response: IApiResponse = yield call(fetchBusinessSettingsApi, { merchantId })

  if (response.type === API_RESPONSE_TYPE.FAILURE) {
    yield put(setBusinessSettingsAction({}))
    return
  }
  yield put(setBusinessSettingsAction(response.data.settings))
}

export function* createBusinessEffect(action: Action<string>) {
  try {
    yield put(setBusinessAccountsLoaderAction(true))
    const response: IApiResponse = yield call(IdentityApi.createBusinessUser, action.payload)
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      const formattedResponse = formatBusinessDetail(response?.data)
      yield put(createBusinessSuccessAction(formattedResponse))
      const refreshToken = AuthStorageInstance.getRefreshToken()
      if (refreshToken) {
        const refreshApiResponse: IApiResponse = yield call(AuthApi.authRefreshToken, refreshToken)
        const { access_token, refresh_token, expires_in } = refreshApiResponse.data
        setNewTokensToLocalStorage(access_token, parseInt(expires_in), refresh_token)
        yield put(switchBusinessAccountAction(formattedResponse.id))
      }
    } else {
      const errMsg =
        response?.data?.response?.data?.error === 'business_limit_reached'
          ? "Couldn't create business. Maximum business count limit reached"
          : 'Could not create business, please try again.'
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: errMsg
        })
      )
    }
    yield put(setBusinessAccountsLoaderAction(false))
    yield put(handleBusinessAccountsDrawerToggle({ newBusinessName: false }))
  } catch (e: any) {
    console.log(e)
    yield put(setBusinessAccountsLoaderAction(false))
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: e.message
      })
    )
  }
}

export function* switchBusinessAccountEffect(action: Action<string>) {
  try {
    const newBusinessId = action.payload
    const { Experiment } = yield select((app: IAppState) => app)
    yield put(setBusinessAccountsLoaderAction(true))
    AuthStorageInstance.setCurrentBusinessId(newBusinessId)
    yield delay(1000)

    const { currentBusinessConfig } = yield select((app: IAppState) => app.Dashboard)
    const visibleScreens = currentBusinessConfig?.visible_screens
      ? currentBusinessConfig?.visible_screens
      : undefined
    const getDefaultRedirectUrl = () => {
      const url = Experiment.ab.staff_link ? newPaths.approve : newPaths.ledger
      if (!visibleScreens) {
        return url
      }
      return newPaths.approve
    }

    window.location.href = getDefaultRedirectUrl()
  } catch (e: any) {
    console.log(e)
    yield put(setBusinessAccountsLoaderAction(false))
  }
}

export function* selectBusinessAccountEffect(
  action: Action<{ businessId: string; isAdmin: boolean }>
) {
  try {
    let merchantProfile
    let merchantBusinessConfig
    const { businessId, isAdmin } = action.payload
    const dashboardState: IDashboardState = yield select((state) => state.Dashboard)
    yield put(setBusinessAccountsLoaderAction(true))
    AuthStorageInstance.setCurrentBusinessId(businessId)
    AuthStorageInstance.setIsAdmin(isAdmin)
    if (isAdmin) {
      merchantProfile = dashboardState?.businessAccounts?.businessDetails?.[businessId]
      merchantBusinessConfig = dashboardState?.businessConfigWithBusinessId?.[businessId]
      yield put(fetchBusinessManagersAction({ businessId }))
    } else {
      merchantProfile = dashboardState?.businessAccounts?.asStaffBusinessDetails?.[businessId]
      merchantBusinessConfig = dashboardState?.businessConfigWithBusinessId?.[businessId]
    }
    if (merchantProfile) {
      yield put(fetchMerchantProfileSuccess(merchantProfile))
      yield put(showSuccessModal())
      // Convergence point for login + boot + returning user: seed this business's
      // full transaction history from the proto file (foreground/blocking), then
      // background-seed the other owned businesses.
      yield put(seedTransactions({ businessId, isActive: true }))
    }

    if (merchantBusinessConfig) {
      yield put(fetchMerchantBusinessConfigSuccess(merchantBusinessConfig))
    }

    yield put(setBusinessAccountsLoaderAction(false))
    yield put(closeSelectAccountModal())

    // Realtime sync: register this browser for FCM push (or nudge for permission)
    // and link it to the just-selected business, so remote transaction changes
    // refresh the ledger without a manual reload.
    yield put(initRealtimeSync({ businessId }))
  } catch (e: any) {
    console.log(e)
    yield put(setBusinessAccountsLoaderAction(false))
    yield put(closeSelectAccountModal())
  }
}

export function* deleteBusinessManagerEffect(
  action: Action<{
    userId: string
    mobile: string
  }>
) {
  const { userId, mobile } = action.payload
  const dashboardState: IDashboardState = yield select((app: IAppState) => app.Dashboard)
  try {
    const response: IApiResponse = yield call(IdentityApi.revokeBusinessManager, mobile)
    if (response.type !== API_RESPONSE_TYPE.SUCCESS) {
      throw new Error('Could not delete business manager. Please try again later.', {
        cause: 'customError'
      })
    }
    const updatedManagers = dashboardState.businessManagers.filter(
      (manager) => manager.user_id !== userId
    )
    yield put(setBusinessManagersAction(updatedManagers))
    yield put(
      addAutoFadeNotification({
        type: NotificationType.SUCCESS,
        bodyText: i18next.t('dashboard:Manager removed successfully')
      })
    )
    Navigation().back()
  } finally {
    yield put(setBusinessManagerActionInProgressAction(false))
  }
}

export function* fetchBusinessManagersEffect(action: Action<{ businessId: string }>) {
  const { businessId } = action.payload
  const businessManagerResponse: IApiResponse = yield call(
    IdentityApi.getBusinessManager,
    businessId
  )
  if (businessManagerResponse.type !== API_RESPONSE_TYPE.SUCCESS) {
    throw new Error('Something went wrong while fetching business managers, please refresh.', {
      cause: 'customError'
    })
  }
  yield put(setBusinessManagersAction(businessManagerResponse?.data?.managers))
}

export function* addBusinessManagerEffect(
  action: Action<{
    mobile: string
  }>
) {
  const { mobile } = action.payload
  const dashboardState: IDashboardState = yield select((app: IAppState) => app.Dashboard)
  const businessId = dashboardState.merchantProfile?.data?.id
  if (!businessId) {
    yield put(setBusinessManagerActionInProgressAction(false))
    return
  }
  try {
    const response: IApiResponse = yield call(IdentityApi.updateBusinessManager, mobile)
    if (response.type !== API_RESPONSE_TYPE.SUCCESS) {
      throw new Error('Could not add business manager. Please try again later.', {
        cause: 'customError'
      })
    }
    yield put(fetchBusinessManagersAction({ businessId }))
    yield put(
      addAutoFadeNotification({
        type: NotificationType.SUCCESS,
        bodyText: i18next.t('dashboard:Manager added successfully')
      })
    )
    Navigation().back()
  } finally {
    yield put(setBusinessManagerActionInProgressAction(false))
  }
}

export function* bulkUploadCustomersEffect(action: Action<any>) {
  try {
    yield put(setLoaderAction({ id: 'bulkUploadCustomers', value: true }))
    const response: IApiResponse = yield call(bulkUploadCustomersApi, {
      document: action.payload.document,
      document_extension: action.payload.documentExtension,
      file_name: action.payload.fileName,
      document_type: DOCUMENT_TYPE.EXCEL
    })
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      yield put(bulkUploadCustomersSuccessAction(response?.data?.document_id))
    } else {
      yield put(
        addAutoFadeNotification({
          type: NotificationType.ERROR,
          bodyText: response?.data?.message || 'Unable to upload document, please contact support'
        })
      )
    }
    yield put(setLoaderAction({ id: 'bulkUploadCustomers', value: false }))
  } catch (e) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e as any).message
      })
    )
    yield put(setLoaderAction({ id: 'bulkUploadCustomers', value: false }))
  }
}

export function* startBulkUploadCustomersStatusPollingEffect(action: Action<any>) {
  let statusPollCount = BULK_UPLOAD_ACCOUNTS_STATUS_POLL_COUNT
  while (statusPollCount > 0) {
    statusPollCount--
    try {
      const response: IApiResponse = yield call(getBulkUploadCustomersStatusApi, action.payload)
      if (response.type === API_RESPONSE_TYPE.FAILURE) {
        yield put(
          addAutoFadeNotification({
            type: NotificationType.ERROR,
            bodyText: 'Document upload failed, please try again.'
          })
        )
        yield put(stopPollBulkUploadAccountsStatus())
        // TODO: Update document status in redux
        return
      }
      /*  DocumentStatus_CREATED            DocumentStatus = 0
    DocumentStatus_UPLOADED           DocumentStatus = 1
    DocumentStatus_DB_CREATED         DocumentStatus = 2
    DocumentStatus_SYNC_STARTED       DocumentStatus = 3
    DocumentStatus_SYNC_COMPLETE      DocumentStatus = 4
    DocumentStatus_SYNC_FAILED        DocumentStatus = 5
    DocumentStatus_READ_FAILED        DocumentStatus = 6
    DocumentStatus_DELETE_IN_PROGRESS DocumentStatus = 7
    DocumentStatus_DELETED            DocumentStatus = 8 */
      yield put(bulkUploadCustomersStatusSuccessAction(response?.data?.document_status))
      // Polling can be stopped if status is >=4
      if (response?.data?.document_status >= DOCUMENT_STATUS.SYNC_COMPLETE) {
        // Upload successful
        if (response?.data?.document_status === DOCUMENT_STATUS.SYNC_COMPLETE) {
          if (response?.data?.unSynced_rows === 0) {
            yield put(
              addAutoFadeNotification({
                type: NotificationType.SUCCESS,
                bodyText: 'Document uploaded successfully.'
              })
            )
          } else {
            yield put(
              addAutoFadeNotification({
                type: NotificationType.NEUTRAL,
                bodyText: `Failed to update ${response?.data?.unSynced_rows} rows`
              })
            )
          }
          yield put(fetchEntityList(ENTITY_TYPE.CUSTOMER))
          yield delay(3000)
          yield put(getBusinessLabelsKeyVals())
        } else {
          yield put(
            addAutoFadeNotification({
              type: NotificationType.ERROR,
              bodyText:
                response?.data?.document_status === DOCUMENT_STATUS.READ_FAILED
                  ? 'Incorrect file format.'
                  : 'Document upload failed, please try again.'
            })
          )
        }
        yield put(stopPollBulkUploadAccountsStatus())
      }
      yield delay(BULK_UPLOAD_ACCOUNTS_STATUS_POLL_INTERVAL)
    } catch (error) {
      // TODO: Update document status in redux
      yield put(stopPollBulkUploadAccountsStatus())
    }
  }
}

export function* fetchCustomerProfilesEffect(action: Action<any>) {
  const response: IApiResponse = yield call(getAllCustomerProfilesApi, action.payload)
  const { sort_by, sort_descending, search_string } = action.payload
  if (response.type === API_RESPONSE_TYPE.FAILURE) {
    throw new Error('Problem while fetching customer profiles, please try after sometime', {
      cause: 'customError'
    })
  }

  const formattedData = formatCustomerProfiles(response?.data, {
    sort_by,
    sort_descending,
    search_string
  })
  yield put(setCustomerProfilesData(formattedData))
}

export function* bulkAddAccountTagsEffect(action: Action<linkDelinkAccountTagsPayload>) {
  const dashboardState: IDashboardState = yield select((app: IAppState) => app.Dashboard)
  const {
    customerProfiles: {
      paginationData,
      sort_by,
      sort_descending,
      search_string,
      resetSelectedRowRef
    }
  } = dashboardState
  const { per_page } = paginationData

  const response: IApiResponse = yield call(linkDelinkAccountTags, action.payload)
  if (response.type !== API_RESPONSE_TYPE.SUCCESS) {
    throw new Error('Could not add tag(s). Please try again later.', {
      cause: 'customError'
    })
  }
  yield delay(100)
  yield put(getAccountTagsSuccess(response?.data?.account_tags))
  yield put(
    fetchCustomerProfiles({
      page_no: 1,
      page_size: per_page,
      search_string,
      sort_by,
      sort_descending
    })
  )
  yield put(setDrawerAction({ id: CustomerProfileBulkUpdateEntity.tag, value: false }))
  resetSelectedRowRef?.customersTable?.current?.resetRowSelection({})
}

export function* bulkAddAccountBeatRouteEffect(action: Action<addAccountBeatRoutePayload>) {
  const dashboardState: IDashboardState = yield select((app: IAppState) => app.Dashboard)
  const {
    customerProfiles: {
      paginationData,
      sort_by,
      sort_descending,
      search_string,
      resetSelectedRowRef
    }
  } = dashboardState
  const { per_page } = paginationData

  const { data, itemType } = action.payload
  const payload = {
    data,
    userId: dashboardState.businessAccounts.individualUser?.id || ''
  }

  const response: IApiResponse = yield call(updateRoutesAndBeats, payload)
  if (response.type !== API_RESPONSE_TYPE.SUCCESS) {
    throw new Error(`Could not add ${itemType}(s). Please try again later.`, {
      cause: 'customError'
    })
  }
  yield delay(100)
  yield put(
    fetchCustomerProfiles({
      page_no: 1,
      page_size: per_page,
      search_string,
      sort_by,
      sort_descending
    })
  )
  yield put(setDrawerAction({ id: itemType, value: false }))
  resetSelectedRowRef?.customersTable?.current?.resetRowSelection({})
}

// Marks the Transaction Alert settings as shown for an account. Wire semantics (KMP
// UpdateAccountImpl): server display_txn_alert_setting=false means "already shown", and
// update_display_txn_alert_setting=true tells the backend to apply it.
export function* markTxnAlertSettingSeen(action: Action<ITxnAlertNudge>) {
  const { entityId, entityType } = action.payload
  try {
    if (entityType === ENTITY_TYPE.CUSTOMER) {
      yield call(CustomerAndSupplierApi.patchCustomer, entityId, {
        display_txn_alert_setting: false,
        update_display_txn_alert_setting: true
      })
    } else {
      yield call(CustomerAndSupplierApi.patchSupplier, entityId, {
        supplier: { display_txn_alert_setting: false },
        update_display_txn_alert_setting: true
      })
    }
  } catch (e) {
    // Best effort: the reducer already cleared the flag locally; the next list fetch decides
    console.warn('[markTxnAlertSettingSeen] failed:', e)
  }
}

// Pending entries live 24h, like KMP PendingTxnAlertUpgrades.
const PENDING_TXN_ALERT_UPGRADE_MAX_AGE_MS = 24 * 60 * 60 * 1000

// After a subscription payment settles: if the bought plan sends alerts and an account is
// waiting (Buy Plan from its alert settings), switch that account's Transaction Alert on and
// mark the settings seen — then forget the entry (KMP ApplyPendingTxnAlertUpgrades).
export function* applyPendingTxnAlertUpgrade(action: Action<{ benefits: string[] }>) {
  const pending: IPendingTxnAlertUpgrade | null = yield select(
    (state: IAppState) => state.Dashboard.pendingTxnAlertUpgrade
  )
  if (!pending) {
    return
  }
  if (Date.now() - pending.savedAt >= PENDING_TXN_ALERT_UPGRADE_MAX_AGE_MS) {
    yield put(clearPendingTxnAlertUpgrade())
    return
  }
  const benefits = action.payload.benefits || []
  const bought =
    pending.awaited === 'whatsapp'
      ? benefits.some(isWhatsappAlertBenefit)
      : sendsOkcAlerts(benefits)
  if (!bought) {
    return
  }
  const { entityId, entityType } = pending
  // editEntity is debounced into the profile PATCH by the watcher (same path as the toggle)
  yield put(editEntity({ key: 'txnAlertEnabled', entityId, entityType, value: true }))
  yield put(markTxnAlertSettingSeenAction({ entityId, entityType }))
  yield put(clearPendingTxnAlertUpgrade())
}

// Profile photo (customer / supplier): the Drive URL is already on the account in the store
// (optimistic, like KMP showing the picked file at once); persist it the way the apps do —
// customer PUT /customer/{id} with profile_image, supplier PATCH /sc/suppliers/{id} with
// supplier.profile_image (LedgerImpl.fileUploadCompleted → UpdateAccount(UpdateProfileImage)).
export function* setAccountProfileImageEffect(action: Action<IAccountProfileImagePayload>) {
  const { entityId, entityType, url } = action.payload
  const isCustomer = entityType === ENTITY_TYPE.CUSTOMER
  const entity: ICustomer & ISupplier = yield select(
    (state: IAppState) => state.Dashboard[isCustomer ? 'customers' : 'suppliers'].byIds[entityId]
  )
  if (!entity) {
    return
  }
  // Like KMP's full UpdateCustomer/UpdateSupplier request: the current fields plus the photo.
  // A bare `{ profile_image: "" }` is ignored by the backend, so removal needs the full body.
  const base = isCustomer
    ? CustomerSupplierProfileHelpers.getPatchCustomerPayload(entity)
    : CustomerSupplierProfileHelpers.getPatchSupplierPayload(entity)
  // NOTE: the ledger backend keeps the stored photo when profile_image is "" or null (verified
  // on staging), so this path only ever SETS a photo; removal is not offered for accounts.
  const payload = isCustomer
    ? { ...base, profile_image: url }
    : { ...base, supplier: { ...base.supplier, profile_image: url } }
  try {
    const response: IApiResponse = yield call(
      isCustomer ? CustomerAndSupplierApi.patchCustomer : CustomerAndSupplierApi.patchSupplier,
      entityId,
      payload
    )
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      const raw = isCustomer ? response.data : response.data?.supplier
      if (raw && raw.id) {
        yield put(
          updateEntity(
            isCustomer ? getFormattedCustomerProfile(raw) : getFormattedSupplierProfile(raw)
          )
        )
      }
      return
    }
    throw response.data
  } catch (e: any) {
    // Roll back to what the server has
    yield put(fetchEntityList(entityType))
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message || i18next.t('dashboard:PhotoUploadFailed')
      })
    )
  }
}

// Business photo: identity UpdateBusinessUser with profile_image + update_profile_image
// (KMP IdentityRepository.fileUploadCompleted), then the refreshed business user in the store.
export function* setBusinessProfileImageEffect(action: Action<{ url: string }>) {
  const merchantProfile: { data?: IMerchantProfile } = yield select(
    (state: IAppState) => state.Dashboard.merchantProfile
  )
  const original = merchantProfile.data
  if (!original) {
    return
  }
  try {
    const response: IApiResponse = yield call(updateBusinessUser, {
      business_user_id: original.id,
      business_user: {
        user: {
          mobile: original.mobile,
          display_name: original.name,
          profile_image: action.payload.url || null
        }
      },
      update_profile_image: true
    })
    if (response.type === API_RESPONSE_TYPE.SUCCESS) {
      // Re-read the business user so the store keeps its full shape (formatBusinessDetail
      // takes the response BODY; PATCH_MERCHANT_PROFILE merges, so undefined fields would wipe
      // the name / id).
      const currentBusinessId: string = yield AuthStorageInstance.getCurrentBusinessId()
      const fresh: IApiResponse = yield call(IdentityApi.getBusinessUser, currentBusinessId)
      if (fresh.type === API_RESPONSE_TYPE.SUCCESS && fresh.data?.business_user) {
        yield put(updateMerchantProfile(formatBusinessDetail(fresh.data)))
      } else {
        yield put(updateMerchantProfile({ ...original, profileImage: action.payload.url }))
      }
      return
    }
    throw response.data
  } catch (e: any) {
    yield put(
      addAutoFadeNotification({
        type: NotificationType.ERROR,
        bodyText: getErrorMessage(e).message || i18next.t('dashboard:PhotoUploadFailed')
      })
    )
  }
}
